import { lazy } from 'react';

export const SellerPageAsync = lazy(() => import('./SellerPage'));
